// extracted by mini-css-extract-plugin
module.exports = {"Sample":"LandingSample_Sample__2WsCB","sketch":"LandingSample_sketch__1df-H"};